// src/components/alert/AboutAboRecipients.tsx

import {
  Alert,
  AlertProps,
  AlertTitle,
  SxProps,
  Theme,
  Typography,
} from '@mui/material'

type Props = {
  data?: { text: string; sx?: object }[]
  severity?: AlertProps['severity']
  title?: string
  sx?: SxProps<Theme>
}

export const AboutAboRecipients = ({
  data = [
    {
      text: 'Tragen Sie eine E-Mail Adresse ein, die zur Empfänger-Liste hinzugefügt werden soll. Klicken Sie zum Bestätigen auf <strong>+</strong>.',
    },
    {
      text: 'Wiederholen Sie diesen Vorgang, bis Sie mit der Empfänger-Liste zufrieden sind und klicken Sie dann auf <strong>Abonnieren</strong> bzw. <strong>Abo aktualisieren</strong>.',
    },
    {
      sx: { mt: 2 },
      text: 'Hinweis: Das <strong>+</strong> Zeichen ist deaktiviert, bis die E-Mail Adresse ein gültiges Schema aufweist.',
    },
    {
      text: 'Hinweis: Unerwünschte E-Mail Adressen lassen sich über den Papierkorb wieder entfernen.',
    },
  ],
  severity = 'info',
  title = 'Hinzufügen von E-Mail Adressen zur Empfänger-Liste',
  ...rest
}: Props) => (
  <Alert severity={severity} {...rest}>
    <AlertTitle>{title}</AlertTitle>

    {data.map(item => (
      <Typography
        dangerouslySetInnerHTML={{ __html: item.text }}
        key={item.text}
        sx={item?.sx}
      />
    ))}
  </Alert>
)
